// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__rtuw8","col":"styles_col__3BpgO","fulfillmentStatus":"styles_fulfillmentStatus__1jW4z","emailCol":"styles_emailCol__3BANI"};